import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { ConversionForm, type ConversionFormData } from '../forms/conversion-form';
import type { PortfolioInput } from '../../lib/investments';
import type { InvestmentAsset } from '../../types';

export interface ConversionDialogProps {
  open: boolean;
  assets: InvestmentAsset[];
  portfolio: PortfolioInput;
  onSubmit: (data: ConversionFormData) => void;
  onClose: () => void;
}

export function ConversionDialog({
  open,
  assets,
  portfolio,
  onSubmit,
  onClose,
}: ConversionDialogProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogPortal>
        <DialogBackdrop className="z-40" />
        <DialogPopup className="z-41 max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Conversão de papel</DialogTitle>
            <DialogCloseButton />
          </DialogHeader>
          <DialogContent>
            <ConversionForm
              onSubmit={onSubmit}
              onClose={onClose}
              assets={assets}
              portfolio={portfolio}
            />
          </DialogContent>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  );
}
